import { Component, OnInit, Inject, Optional, ViewChild } from '@angular/core';
import {
	PhoneNumberComponent,
	phoneNumberFormConfig,
} from '../phone-number.component';
import { PhoneNumber } from 'src/shared/api';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filter, takeUntil } from 'rxjs/operators';

/*
	TODO come up with a better approach to this. Right now I _need_
	a FormGroup type back from this dialog. Only problem is it's
	accessing values from components that implement the CVA, which
	can only be listened to through a FormControl. So I'm having to
	do some manual mapping from formcontrol to formgroup.
*/

@Component({
	selector: 'rpshared-phone-number-dialog',
	templateUrl: './phone-number-dialog.component.html',
	styleUrls: ['./phone-number-dialog.component.css'],
})
export class PhoneNumberDialogComponent extends SelfDestruct implements OnInit {
	// CVA components can only be listened to through a form control
	@ViewChild(PhoneNumberComponent)
	phoneNumberComponent: PhoneNumberComponent;
	control = new FormControl('') as FormControl;

	group = this.fb.group(phoneNumberFormConfig) as FormGroup;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		@Optional()
		private readonly phone: PhoneNumber,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		this.control.valueChanges
			.pipe(filter(Boolean), takeUntil(this.destroyed))
			.subscribe((v) => this.group.setValue(v));

		if (this.phone) {
			this.control.setValue(this.phone);
		}
	}
	get getPhoneControlInvalid() {
		if (this.phoneNumberComponent) {
			return this.phoneNumberComponent.phoneNumberInput.invalid;
		}
		return true;
	}
}
